module.exports = __webpack_public_path__ + "img/cv_todorov.477e5d20.jpg";